import { useEffect, useRef } from "react"
import Mousetrap from "mousetrap"

export default function useKeyBinding(keys: string, callback: () => void) {
	let callbackRef = useRef<() => void>()

	// Note: It is important that we pass this through as a ref so that state
	// updates that occur while typing a keybinding do not cause the listener
	// below to `.unbind()` and re-`.bind()`
	useEffect(() => {
		callbackRef.current = callback
	}, [callback])

	useEffect(() => {
		Mousetrap.bind(keys, () => {
			if (callbackRef.current) {
				callbackRef.current()
			}
		})

		return () => {
			Mousetrap.unbind(keys)
		}
	}, [keys, callbackRef])
}
